// Idea for a separate firebase.js file came from here:
// https://www.youtube.com/watch?v=831zOI02Q_0

import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDwti_8lx29vSbIiQO9mBHGtm2T03U0JsE",
  authDomain: "o2a-orbita-2.firebaseapp.com",
  databaseURL: "https://o2a-orbita-2.firebaseio.com",
  projectId: "o2a-orbita-2",
  storageBucket: "o2a-orbita-2.appspot.com",
  messagingSenderId: "169579685982"
});
export const auth = firebaseApp.auth();
const db = firebaseApp.database();

// Globals
export const systemStatusRef = db.ref("rAll-wHq/systemStatus");
export const amOnlineRef = db.ref(".info/connected");

// These roots then have branches per user
export const contactRootRef = db.ref("contacts");
export const privilegesRootRef = db.ref("privileges");
export const presenceRootRef = db.ref("presence");
export const statusRootRef = db.ref("status");
export const logRootRef = db.ref("log");
export const debugRootRef = db.ref("debug");

// General constants
export const ServerValueTIMESTAMP = firebase.database.ServerValue.TIMESTAMP;



// WEBPACK FOOTER //
// ./src/firebaseSetup.js